import { ApiClient } from '@/lib/axios/client';
import type { CreateImageUploadSessionDto, ImageUploadSessionResult } from './types';

export class ImageUploadSessionApi {
  static async create(orgId: string, dto: CreateImageUploadSessionDto): Promise<ImageUploadSessionResult> {
    return await ApiClient.post<ImageUploadSessionResult>(
      `/api/v1/orgs/${orgId}/master-data/image-upload-sessions`,
      dto
    );
  }

  static async get(orgId: string, sessionId: string): Promise<ImageUploadSessionResult> {
    return await ApiClient.get<ImageUploadSessionResult>(
      `/api/v1/orgs/${orgId}/master-data/image-upload-sessions/${sessionId}`
    );
  }
}
